/* Resource Portal
  -> entry point
*/
import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './Root';

let initProps;
function ResourcePortalRoot(props) {
  initProps = props;
  return <Root {...props} />;
}

// Hot reloading
if (module.hot) {
  module.hot.accept('./Root', () => {
    const NextRoot = require('./Root').Root;
    ReactDOM.render(
      <NextRoot {...initProps} />,
      document.getElementById('react-root')
    );
  });
}

export default ResourcePortalRoot;
